import { Context } from '@micro-frontend-react/employee-experience/lib/Context';
import { IEmployeeExperienceContext } from '@micro-frontend-react/employee-experience/lib/IEmployeeExperienceContext';
import { Context as ReactContext,useContext, useEffect, useState } from 'react';

import { SubscriptionNode } from '../../Common/ConsumerModels/SubcriptionNode';
import {
  addSubscriptionNodeFieldsForApproved,
  filterBySearchQuery,
} from '../../Common/Helper/subscriptionNodeHelper';

export function useGetApprovedSubscriptionAttributes(environment: number, subscriberId: string, searchQuery: string) {
  const [formattedSubscriptionNodes, setFormattedSubscriptionNodes] = useState<SubscriptionNode[]>([]);
  const [filteredSubscriptionNodes, setFilteredSubscriptionNodes] = useState<SubscriptionNode[]>([]);
  const [isAttributeSubscriptionLoading, setIsAttributeSubscriptionLoading] = useState<boolean>(true);
  const { httpClient } = useContext(Context as ReactContext<IEmployeeExperienceContext>);

  useEffect(() => {
    let cancelled = false;
    setIsAttributeSubscriptionLoading(true);
    httpClient
      .get<SubscriptionNode[]>(
        `${__API_BASE_URL__}/subscriber/approvedSubscriptionAttributes?requestEnvironment=${environment}&subscriberId=${subscriberId}`,
        {
          resource: __CLIENT_ID__,
          headers: {
            'Content-Type': 'application/json',
            'X-Content-Type-Options': 'nosniff',
          },
        }
      )
      .then(({ data }) => {
        if (cancelled) return;
        const formattedNodeList: SubscriptionNode[] = addSubscriptionNodeFieldsForApproved(data);
        const newFormattedApprovedAttributes: SubscriptionNode[] = JSON.parse(
          JSON.stringify(formattedNodeList) // deep copy
        );
        const newFilteredApprovedAttributes: SubscriptionNode[] = JSON.parse(
          JSON.stringify(formattedNodeList) // deep copy
        );
        setFormattedSubscriptionNodes(newFormattedApprovedAttributes);
        setFilteredSubscriptionNodes(newFilteredApprovedAttributes);
        setIsAttributeSubscriptionLoading(false);
      })
      .catch((error) => {
        if (cancelled) return;
        setFormattedSubscriptionNodes([]);
        setFilteredSubscriptionNodes([]);
        setIsAttributeSubscriptionLoading(false);
      });
    return () => { cancelled = true; };
  }, [environment]);

  useEffect(() => {
    const approvedAttributesFilteredBySearchQuery: SubscriptionNode[] = filterBySearchQuery(
      formattedSubscriptionNodes,
      searchQuery
    );
    setFilteredSubscriptionNodes(approvedAttributesFilteredBySearchQuery);
  }, [searchQuery]);

  return [
    formattedSubscriptionNodes,
    setFormattedSubscriptionNodes,
    filteredSubscriptionNodes,
    setFilteredSubscriptionNodes,
    isAttributeSubscriptionLoading,
  ] as const;
}
